import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import "./css/ToastWithAction.css";

/**
 * Custom Toast Component with Action Button and Countdown
 * Displays a confirmation toast with a countdown timer and action buttons
 */
const ToastContent = ({ message, onConfirm, onCancel, countdown, t }) => {
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    if (timeLeft <= 0) {
      onCancel();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onCancel]);

  return (
    <div className={`toast-with-action ${t.visible ? "visible" : ""}`}>
      <div className="toast-message">{message}</div>
      <div className="toast-actions">
        <button
          className="toast-btn toast-btn-confirm"
          onClick={() => {
            onConfirm();
            toast.dismiss(t.id);
          }}
        >
          Confirm ({timeLeft}s)
        </button>
        <button
          className="toast-btn toast-btn-cancel"
          onClick={() => {
            onCancel();
            toast.dismiss(t.id);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

/**
 * Show a toast with action buttons and countdown
 * @param {string} message - Message to display
 * @param {function} onConfirm - Callback when confirmed
 * @param {number} countdown - Countdown duration in seconds (default: 5)
 * @returns {string} Toast ID
 */
export const showToastWithAction = (message, onConfirm, countdown = 5) => {
  return toast.custom(
    (t) => (
      <ToastContent
        message={message}
        onConfirm={onConfirm}
        onCancel={() => toast.dismiss(t.id)}
        countdown={countdown}
        t={t}
      />
    ),
    {
      duration: countdown * 1000,
      position: "top-center",
    }
  );
};

export default ToastContent;
